import { render, staticRenderFns } from "./DevTreeMenu.vue?vue&type=template&id=3229dc6a&scoped=true"
import script from "./DevTreeMenu.vue?vue&type=script&lang=js"
export * from "./DevTreeMenu.vue?vue&type=script&lang=js"
import style0 from "./DevTreeMenu.vue?vue&type=style&index=0&id=3229dc6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3229dc6a",
  null
  
)

export default component.exports